export function obterDataAtual() {
    return new Date();
  }
  
  // Função para converter uma data em string
export function converterDataParaString(data) {
    return data.toISOString(); // Formato ISO 8601
  }

  
export function formatarDataParaString(data) {
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Mês é baseado em zero
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");
  
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
  }

  export function formatarDataParaStringSemHora(data) {
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Mês é baseado em zero
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

 export function isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
}

export function convertBrazilianDateTimeToJSDate(dateTimeString) {
  // Regex para validar o formato DD/MM/YYYY HH:MM
  const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
  const match = dateTimeString.match(regex);

  if (!match) {
      throw new Error("Formato inválido. Use DD/MM/YYYY HH:MM.");
  }

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1; // Meses começam em 0 no JavaScript
  const year = parseInt(match[3], 10);
  const hours = parseInt(match[4], 10);
  const minutes = parseInt(match[5], 10);

  // Cria e retorna o objeto Date
  return new Date(year, month, day, hours, minutes);
}

export function  convertBrazilianDateToJSDate(dateString) {
  // Verifica se está no formato DD/MM/YYYY usando regex
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateString.match(regex);

  if (!match) {
      throw new Error("Formato de data inválido. Use DD/MM/YYYY.");
  }

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1; // Meses começam em 0 no JavaScript
  const year = parseInt(match[3], 10);

  // Retorna um objeto Date
  return new Date(year, month, day);
}

export function convertISOToDate(isoString) {
  return new Date(isoString);
}

export function isValidBrazilianDateTime(dateTimeString) {
  // Regex para validar o formato DD/MM/YYYY HH:MM
  const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
  const match = dateTimeString.match(regex);

  if (!match) return false;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1; // Meses começam em 0 no JavaScript
  const year = parseInt(match[3], 10);
  const hours = parseInt(match[4], 10);
  const minutes = parseInt(match[5], 10);

  // Valida se a data e hora são válidas
  const date = new Date(year, month, day, hours, minutes);

  return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day &&
      date.getHours() === hours &&
      date.getMinutes() === minutes
  );
}

export function isValidBrazilianDate(dateString) {
  // Verifica se está no formato DD/MM/YYYY usando regex
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateString.match(regex);

  if (!match) return false;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1; // Meses começam em 0 no JavaScript
  const year = parseInt(match[3], 10);

  // Cria uma data com os valores extraídos
  const date = new Date(year, month, day);

  // Verifica se a data criada é válida e corresponde aos valores originais
  return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
  );
}

export function converterStringParaData(dataString) {
    const [dataPart, horaPart] = dataString.split(" ");
    const [dia, mes, ano] = dataPart.split("/").map(Number);
    const [horas, minutos] = horaPart.split(":").map(Number);
  
    return new Date(ano, mes - 1, dia, horas, minutos); // Mês é baseado em zero
  }

  export function converterDataUSParaBR(dataUS) {
    const [mes, dia, ano] = dataUS.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  export function gerarGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const rand = Math.random() * 16 | 0;
      const valor = char === 'x' ? rand : (rand & 0x3 | 0x8);
      return valor.toString(16);
    });
  }